
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index2vgLDPOS3JWoe5x79062dNxVHSFV7xeuK3OohZBvZlYMeta } from "/builds/magyar-telekom/ida-comind-ui/pages/index.vue?macro=true";
import { default as cookieIA_45dQy8xnZN_reYORfzV9nabPngwbPThRhzoKZAvXxEMeta } from "/builds/magyar-telekom/ida-comind-ui/pages/cookie.vue?macro=true";
import { default as ai_45modezJfe9t4DqbsNasil7vshVDWDEjFux7vXr6bZriljlRsMeta } from "/builds/magyar-telekom/ida-comind-ui/pages/ai-mode.vue?macro=true";
import { default as custom_45packageBuSfcqxKM37zp8vSZham6Qw6_45gsZX7EmiXGNWwG7ui8Meta } from "/builds/magyar-telekom/ida-comind-ui/pages/custom-package.vue?macro=true";
import { default as _91slug_93pRAhVrFYdRrc5xTQetqBtGekbmPa6ZLPdiitsYUs1uIMeta } from "/builds/magyar-telekom/ida-comind-ui/pages/use-cases/[slug].vue?macro=true";
import { default as _91dslug_9309FSLhSnoqSqgVVydOyBgtDl7iG7mV5VWwXVJJ2zJbQMeta } from "/builds/magyar-telekom/ida-comind-ui/pages/documents/[dslug].vue?macro=true";
import { default as component_45stubTvhCQWU6o_AsIxBa6Q2UoXGkNM4IU3xdZGPKMWba6IQMeta } from "/builds/magyar-telekom/ida-comind-ui/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubTvhCQWU6o_AsIxBa6Q2UoXGkNM4IU3xdZGPKMWba6IQ } from "/builds/magyar-telekom/ida-comind-ui/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/builds/magyar-telekom/ida-comind-ui/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/builds/magyar-telekom/ida-comind-ui/pages/index.vue")
  },
  {
    name: "index___hu",
    path: "/hu",
    component: () => import("/builds/magyar-telekom/ida-comind-ui/pages/index.vue")
  },
  {
    name: "cookie___en",
    path: "/en/cookie-settings",
    component: () => import("/builds/magyar-telekom/ida-comind-ui/pages/cookie.vue")
  },
  {
    name: "cookie___hu",
    path: "/hu/cookie-beallitasok",
    component: () => import("/builds/magyar-telekom/ida-comind-ui/pages/cookie.vue")
  },
  {
    name: "ai-mode___en",
    path: "/en/ai-mode",
    meta: ai_45modezJfe9t4DqbsNasil7vshVDWDEjFux7vXr6bZriljlRsMeta || {},
    component: () => import("/builds/magyar-telekom/ida-comind-ui/pages/ai-mode.vue")
  },
  {
    name: "ai-mode___hu",
    path: "/hu/ai-mod",
    meta: ai_45modezJfe9t4DqbsNasil7vshVDWDEjFux7vXr6bZriljlRsMeta || {},
    component: () => import("/builds/magyar-telekom/ida-comind-ui/pages/ai-mode.vue")
  },
  {
    name: "custom-package___en",
    path: "/en/custom-package",
    component: () => import("/builds/magyar-telekom/ida-comind-ui/pages/custom-package.vue")
  },
  {
    name: "custom-package___hu",
    path: "/hu/egyedi-csomag",
    component: () => import("/builds/magyar-telekom/ida-comind-ui/pages/custom-package.vue")
  },
  {
    name: "use-cases-slug___en",
    path: "/en/use-cases/:slug()",
    component: () => import("/builds/magyar-telekom/ida-comind-ui/pages/use-cases/[slug].vue")
  },
  {
    name: "use-cases-slug___hu",
    path: "/hu/hasznalati-esetek/:slug()",
    component: () => import("/builds/magyar-telekom/ida-comind-ui/pages/use-cases/[slug].vue")
  },
  {
    name: "documents-dslug___en",
    path: "/en/documents/:dslug()",
    component: () => import("/builds/magyar-telekom/ida-comind-ui/pages/documents/[dslug].vue")
  },
  {
    name: "documents-dslug___hu",
    path: "/hu/dokumentumok/:dslug()",
    component: () => import("/builds/magyar-telekom/ida-comind-ui/pages/documents/[dslug].vue")
  },
  {
    name: component_45stubTvhCQWU6o_AsIxBa6Q2UoXGkNM4IU3xdZGPKMWba6IQMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubTvhCQWU6o_AsIxBa6Q2UoXGkNM4IU3xdZGPKMWba6IQ
  },
  {
    name: component_45stubTvhCQWU6o_AsIxBa6Q2UoXGkNM4IU3xdZGPKMWba6IQMeta?.name,
    path: "/hu/sitemap.xml",
    component: component_45stubTvhCQWU6o_AsIxBa6Q2UoXGkNM4IU3xdZGPKMWba6IQ
  }
]